import React, { useEffect, useState } from 'react';
import { inmueblesService, contratosService, inquilinosService } from '../services/api';

export default function Dashboard() {
  const [inmuebles, setInmuebles] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [inquilinos, setInquilinos] = useState([]);
  const [vencimientos, setVencimientos] = useState([]);

  useEffect(() => {
    inmueblesService.getAll().then(r => setInmuebles(r.data));
    contratosService.getAll().then(r => setContratos(r.data));
    inquilinosService.getAll().then(r => setInquilinos(r.data));
    contratosService.proximosVencimientos().then(r => setVencimientos(r.data));
  }, []);

  const totalInmuebles = inmuebles.length;
  const alquilados = inmuebles.filter(i => i.estado === 'alquilado').length;
  const disponibles = inmuebles.filter(i => i.estado === 'disponible').length;
  const enVenta = inmuebles.filter(i => i.estado === 'en_venta').length;

  const ingresosUSD = contratos
    .filter(c => c.estado === 'activo' && c.moneda === 'USD')
    .reduce((s, c) => s + parseFloat(c.monto || 0), 0);

  const ingresosUYU = contratos
    .filter(c => c.estado === 'activo' && c.moneda === 'UYU')
    .reduce((s, c) => s + parseFloat(c.monto || 0), 0);

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <span style={{ color: '#888', fontSize: '0.9rem' }}>
          {new Date().toLocaleDateString('es-UY', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </span>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="number">{totalInmuebles}</div>
          <div className="label">Propiedades totales</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#4f8ef7' }}>{alquilados}</div>
          <div className="label">Alquiladas</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#2ecc71' }}>{disponibles}</div>
          <div className="label">Disponibles</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#9b59b6' }}>{enVenta}</div>
          <div className="label">En venta</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#1a1a2e' }}>
            {ingresosUSD > 0 ? `USD ${ingresosUSD.toLocaleString()}` : '-'}
          </div>
          <div className="label">Ingresos mensuales USD</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: '#1a1a2e' }}>
            {ingresosUYU > 0 ? `$ ${ingresosUYU.toLocaleString()}` : '-'}
          </div>
          <div className="label">Ingresos mensuales UYU</div>
        </div>
        <div className="stat-card">
          <div className="number">{inquilinos.length}</div>
          <div className="label">Inquilinos activos</div>
        </div>
        <div className="stat-card">
          <div className="number" style={{ color: vencimientos.length > 0 ? '#e74c3c' : '#2ecc71' }}>
            {vencimientos.length}
          </div>
          <div className="label">Contratos por vencer (60 días)</div>
        </div>
      </div>

      {vencimientos.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <h2 style={{ fontSize: '1rem', color: '#1a1a2e', marginBottom: 14 }}>
            Próximos vencimientos
          </h2>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Inmueble</th>
                  <th>Inquilino</th>
                  <th>Vence</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                {vencimientos.map(v => (
                  <tr key={v.id}>
                    <td>{v.inmueble_nombre}</td>
                    <td>{v.inquilino_nombre} {v.inquilino_apellido}</td>
                    <td style={{ color: '#e74c3c' }}>
                      {new Date(v.fecha_fin).toLocaleDateString('es-UY')}
                    </td>
                    <td>{v.moneda} {parseFloat(v.monto).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totalInmuebles === 0 && (
        <div className="empty-state">
          <h3>Bienvenido al ERP Inmuebles</h3>
          <p>Empezá agregando tu primera propiedad desde el menú Inmuebles</p>
        </div>
      )}
    </div>
  );
}
